__turbopack_context__.v({
  "form": "found-lower-price-form-module-scss-module__kV79_a__form",
  "formField": "found-lower-price-form-module-scss-module__kV79_a__formField",
  "form__agreement": "found-lower-price-form-module-scss-module__kV79_a__form__agreement",
  "form__error": "found-lower-price-form-module-scss-module__kV79_a__form__error",
  "form__icon": "found-lower-price-form-module-scss-module__kV79_a__form__icon",
  "form__item": "found-lower-price-form-module-scss-module__kV79_a__form__item",
  "form__item_city": "found-lower-price-form-module-scss-module__kV79_a__form__item_city",
  "form__item_delivery": "found-lower-price-form-module-scss-module__kV79_a__form__item_delivery",
  "form__item_link": "found-lower-price-form-module-scss-module__kV79_a__form__item_link",
  "form__item_payment": "found-lower-price-form-module-scss-module__kV79_a__form__item_payment",
  "form__submit": "found-lower-price-form-module-scss-module__kV79_a__form__submit",
  "form__success": "found-lower-price-form-module-scss-module__kV79_a__form__success",
  "form__text": "found-lower-price-form-module-scss-module__kV79_a__form__text",
  "link": "found-lower-price-form-module-scss-module__kV79_a__link",
  "mainPrice": "found-lower-price-form-module-scss-module__kV79_a__mainPrice",
  "modal": "found-lower-price-form-module-scss-module__kV79_a__modal",
  "oldPrice": "found-lower-price-form-module-scss-module__kV79_a__oldPrice",
  "product": "found-lower-price-form-module-scss-module__kV79_a__product",
  "product__content": "found-lower-price-form-module-scss-module__kV79_a__product__content",
  "product__price": "found-lower-price-form-module-scss-module__kV79_a__product__price",
  "product__title": "found-lower-price-form-module-scss-module__kV79_a__product__title",
  "text": "found-lower-price-form-module-scss-module__kV79_a__text",
  "title": "found-lower-price-form-module-scss-module__kV79_a__title",
});
